import {
  useAppSelector,
  linkedLayersSelector,
  allPlacedSpacesSelector,
  ImageLayerType,
} from '../../../../../store';

import { GroupedByLayerListItem } from './GroupedByLayerListItem';

import '../GroupedByCategoryList/GroupedByCategoryList.scss';

export function GroupedByLayerList() {
  const allPlacedSpaces = useAppSelector(allPlacedSpacesSelector);
  const linkedLayers = useAppSelector(linkedLayersSelector);

  return (
    <ol id="categorized-spaces">
      {linkedLayers.map((layer, index) => (
        <GroupedByLayerListItem
          key={layer.id}
          layer={layer as ImageLayerType}
          spaces={allPlacedSpaces[Number(layer.id)]}
          index={index}
          open={layer.opened}
        />
      ))}
    </ol>
  );
}
